import type {ListPermissionsSearchInput} from "./list-permissions.schema";
import {listAccessAdministrationPermissions} from "@project/sdk/access-administration";
import {ListAccessAdministrationPermissionsResponse} from "@project/sdk/access-administration/zod";
import {queryOptions} from "@tanstack/react-query";
import {queryPolicyDefaults} from "../../../shared/query/query-policies";
import {permissionKeys} from "../../access-administration-keys";
import {listPermissionsSearchSchema} from "./list-permissions.schema";

export function listPermissionsQueryOptions(input: ListPermissionsSearchInput) {
  const params = listPermissionsSearchSchema.parse(input);
  return queryOptions({
    ...queryPolicyDefaults.warm,
    queryKey: permissionKeys.list(params),
    queryFn: async ({signal}) =>
      ListAccessAdministrationPermissionsResponse.parse(
        await listAccessAdministrationPermissions(params, {signal}),
      ),
  });
}
